let EnvName = "demo";
let Front_URL = "";
let Back_URL = "";
let v1Url = "";
let RpcUrl = "";
let limit = "12";
let limitMax = "3000";
let fee = 2500000000000000000;
let decimalvalues = 1000000000000000000;
let toFixed = 6;
let IPFS_IMG = "https://ipfs.io/ipfs";
const singleType = 721;
const multipleType = 1155;
var providercon = null;
let networkVersion = 56; //mainnet -56,testnet-97
let currencySymbol = "BNB";
let equalTokenSymbol = "WBNB";
let tokenSymbol = "BNJR";
const ownerAddr = "0x49E1a781BffF290350d0EBA905D42823F2308F39";
var liverpcUrls = "";
var livechainid = 0;
var NetworkId = 0;

// Testnet
var lottery = "";
var lotterAdmin = "";
var lotteryToken = "";

var singleContract = "";
var WbnbtokenAddr = "";
var PankukuAddr = "";
var ContractAddress = "";

const userContract721 = "";
const userContract1155 = "";
let toasterOption = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
if (EnvName === "production") {
  Front_URL = "https://lottery.refitplusdefi.com/";
  Back_URL = "https://api.webonjour.com";
  v1Url = "https://lottery.refitplusdefi.com/v1";
  IPFS_IMG = "https://ipfs.io/ipfs";
  RpcUrl = "https://bsc-dataseed.binance.org/";
  liverpcUrls = "https://bscscan.com/";
  livechainid = 56;
  NetworkId = 56;

  //
  lottery = "0x703c976CA913f94494c7594B48403d88f07040a5";
  lotterAdmin = "0x49E1a781BffF290350d0EBA905D42823F2308F39";
  lotteryToken = "0xCb83CF3E0FF414Dc9535B5329Cdc753D1b1D91f1";

  singleContract = "0xF739B96ad8B4efcebB7EcAffed2f560ACDB64517";
  WbnbtokenAddr = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
  PankukuAddr = "0xCb83CF3E0FF414Dc9535B5329Cdc753D1b1D91f1";
  ContractAddress = "0x703c976CA913f94494c7594B48403d88f07040a5";
} else if (EnvName === "demo") {
  Front_URL = "https://demoapi.webonjour.com/";
  Back_URL = "https://demoapi.webonjour.com/";
  v1Url = "https://demoapi.webonjour.com/v1";
  IPFS_IMG = "https://ipfs.io/ipfs";
  RpcUrl = "https://bsc-dataseed.binance.org/";
  liverpcUrls = "https://bsc-dataseed1.binance.org:443/";
  livechainid = 56;
  NetworkId = 56;

  //
  lottery = "0x60dF5E3D560E24f035981FFe4C0f697c860B130B";
  lotterAdmin = "0x49E1a781BffF290350d0EBA905D42823F2308F39";
  lotteryToken = "0x498532dc25045289E34A5Be1A050b3B30C024fcc";

  singleContract = "0xF739B96ad8B4efcebB7EcAffed2f560ACDB64517";
  WbnbtokenAddr = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
  PankukuAddr = "0x1dB3c1545df0c705cceEf4F7d33EFE8854bB8254";
  ContractAddress = "0x60dF5E3D560E24f035981FFe4C0f697c860B130B";
} else {
  // baseUrl= "http://localhost:2057/"
  Front_URL = "http://localhost:3000/";
  Back_URL = "http://localhost:3040";
  v1Url = "http://localhost:2053/v1";
  // Back_URL  = "http://212.71.233.123:5325/";
  // v1Url     = "http://212.71.233.123:5325/v1";
  IPFS_IMG = "https://ipfs.io/ipfs";
  RpcUrl = "https://data-seed-prebsc-1-s1.binance.org:8545/";
  liverpcUrls = "https://data-seed-prebsc-1-s1.binance.org:8545/";
  livechainid = 97;
  NetworkId = 97;
  //
  lottery = "0xe323E73C45a32e6fCDFFA8Ec11FD21490C36681E";
  lotterAdmin = "0x49E1a781BffF290350d0EBA905D42823F2308F39";
  lotteryToken = "0x498532dc25045289E34A5Be1A050b3B30C024fcc";

  singleContract = "0xF739B96ad8B4efcebB7EcAffed2f560ACDB64517";
  WbnbtokenAddr = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
  PankukuAddr = "0x1dB3c1545df0c705cceEf4F7d33EFE8854bB8254";
  ContractAddress = "0xe323E73C45a32e6fCDFFA8Ec11FD21490C36681E";
}

let key = {
  Front_URL: Front_URL,
  Back_URL: Back_URL,
  vUrl: v1Url,
  decimalvalues: decimalvalues,
  toFixed: toFixed,
  networkVersion: networkVersion,
  currencySymbol: currencySymbol,
  tokenSymbol: tokenSymbol,
  equalTokenSymbol: equalTokenSymbol,
  toasterOption: toasterOption,
  limit: limit,
  limitMax: limitMax,
  singleContract: singleContract,
  userContract721: userContract721,
  userContract1155: userContract1155,
  ownerAddr: ownerAddr,
  singleType: singleType,
  multipleType: multipleType,
  ipfsurl: IPFS_IMG,
  providercon: providercon,
  WbnbtokenAddr: WbnbtokenAddr,
  PankukuAddr: PankukuAddr,
  fee: fee,
  lotteryToken: lotteryToken,
  lottery: lottery,
  RpcUrl: RpcUrl,
  LotterytokenSymbol: "WOW",
  liverpcUrls: liverpcUrls,
  livechainid: livechainid,
  lotterAdmin: lotterAdmin,
  ContractAddress: ContractAddress,
  baseUrl: Back_URL,
  NetworkId: NetworkId,
};

export default key;
